import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = { class: "p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PredictionBoard = _resolveComponent("PredictionBoard")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_PredictionBoard, {
        predictions: _ctx.predictions,
        workspaceId: _ctx.workspaceId
      }, null, 8, ["predictions", "workspaceId"])
    ])
  ]))
}